import React from 'react';
import styled from 'styled-components';
import { Size } from '../../common/size';
import { useTestId } from '../../hooks/useTestId';
import { Icon, IconNames, IIconProps } from '../Icons/Icon';
import { IThemePalette } from '../../Themes/interfaces';

export const bannerColours = (palette: IThemePalette) => ({
  banner: {
    label: {
      text: palette.primary.text[100],
      background: palette.alerts.notification
    },
    closeIcon: {
      text: palette.primary.text[100],
      background: palette.neutral.white
    }
  }
});

const BannerContainer = styled.div`
  width: 100%;
  padding: 1rem 2rem;
  margin-bottom: 1rem;
  vertical-align: middle;
  text-align: center;
  color: ${({ theme }) => theme.colours.banner.label.text};
  background-color: ${({ theme }) => theme.colours.banner.label.background};
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  > *:nth-child(1) {
    flex: 1;
  }
  ${Icon} {
    color: ${({ theme }) => theme.colours.banner.closeIcon.text};
    background-color: ${({ theme }) => theme.colours.banner.closeIcon.background};
  }
`;

export interface IBannerProps extends Pick<IIconProps, 'onClick'> {}

export const Banner: React.FC<IBannerProps> = ({ children, onClick, ...props }) => {
  const { generateTestId } = useTestId(props, 'Banner');

  return (
    <BannerContainer {...props} {...generateTestId('Container')}>
      {children}
      <Icon name={IconNames.X} size={Size.Medium} onClick={onClick} {...generateTestId('Icon')} />
    </BannerContainer>
  );
};
